export const USER_ROLES_INIT = "USER_ROLES_INIT"
export const USER_ROLES_REQUEST = "USER_ROLES_REQUEST"
export const USER_ROLES_SUCCESS = "USER_ROLES_SUCCESS"
export const USER_ROLES_REQUEST_FAIL = "USER_ROLES_REQUEST_FAIL"
export const USER_ROLES_ASSIGN = "USER_ROLES_ASSIGN"
export const USER_ROLES_PASS_POPUP_REQUEST = "USER_ROLES_PASS_POPUP_REQUEST"

export const USER_ROLES_POPUP_REQUEST = "USER_ROLES_POPUP_REQUEST"
export const USER_ROLES_POPUP_REQUEST_FAIL = "USER_ROLES_POPUP_REQUEST_FAIL"
